import React from 'react';
import { Moon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="bg-beige py-24 px-6 md:px-12 relative overflow-hidden" data-id="element-86">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-87">
        <FadeIn data-id="element-88">
          <div className="flex justify-center mb-8" data-id="element-89">
            <Moon className="w-12 h-12 text-periwinkle" strokeWidth={1.5} data-id="element-90" />
          </div>
          <p className="text-2xl md:text-3xl font-serif italic text-brown leading-relaxed mb-8" data-id="element-91">
            "Son las 3 de la mañana. Estás sentada en la oscuridad, con los ojos
            ardiendo y un nudo en el estómago, balanceando a tu bebé por cuarta
            vez en la noche. Mirás la cama con desesperación porque sabés que,
            en cuanto lo apoyes, sus ojos se van a abrir de par en par."
          </p>
          <p className="text-lg md:text-xl text-brown/80 font-medium" data-id="element-92">
            No estás sola. Ese agotamiento que nubla tu juicio y te hace sentir
            que la maternidad te supera no es tu culpa. Lo que necesitás es una
            guía clara para ayudar a tu bebé a dormir mejor.
          </p>
        </FadeIn>
      </div>
    </section>;
}